import $api from "../api/axios";

export async function confirmPollingEnd(generationId: number | string) {
  const response = await $api.post(`/chat/${generationId}/process`);
  return response.data;
}
